import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/pilot", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const r = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id }),
        });
        if (r.ok) {
          const data = await r.json();
          setUser(data.user);
        }
      } catch (err) {
        console.error("[auth] session exchange failed:", err);
      }
      // clean hash and go to /pilot
      window.history.replaceState(null, "", "/pilot");
      nav("/pilot", { replace: true });
    })();
  }, [nav, setUser]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black text-primary font-mono text-sm">
      <div className="animate-pulse">CONECTANDO SINAL...</div>
    </div>
  );
}
